
import ItemText from "../Item"
import Badge from "../Badge"

import { useContext } from 'react';
import { DonneesUtilisateurContext } from '../../../../contexte.js';

const SubMenu = ({ items, displayBadge}) => {
    return <div>
        {items.map((item, index) => (
            <div className="block" key={index}>
                {CategoryName(item, index)}
                <div className="mt-2">
                    {ItemsList(item, displayBadge)}
                </div>
            </div>
        ))}
    </div>
}

const CategoryName = (item, index) => (
    <p className={`text-gray-500 text-xs font-sans font-semibold ${index === 1 && `mt-6`}`}>
        {item.categoryName}
    </p>)

const ItemsList = (item, displayBadge) => (
    item.links && item.links.map(({ name, route }, index) => Item(name, route, index, displayBadge)))

/* convertie en fonction pour utiliser usecontext..
const Item = (name, route, index) => (
    <div key={index} className={`flex justify-start my-2`}>
        <ItemText name={name} route={route} />
        {index === 0 && <Badge text="NEW" />}
    </div>)
*/
function Item (name, route, index, displayBadge) {
    const { utilisateurNbFormAttente, utilisateurNbFormIncomplete,
            utilisateurNbActAttente, utilisateurNbActIncomplete, 
            utilisateurNbSessAttente, utilisateurNbSessIncomplete } = useContext(DonneesUtilisateurContext);
return(<div key={index} className={`flex justify-start my-2`}>
        <ItemText name={name} route={route} />
        {displayBadge == true &&
        <>
            {/*index === 1 && <Badge text={utilisateurNbFormAttente + utilisateurNbActAttente + utilisateurNbSessAttente} /> !!! cf #tagCommentBad : si décommenté ici , il faut passer index === 2 ci-dessous*/}
            {index === 1 && <Badge text={utilisateurNbFormIncomplete + utilisateurNbActIncomplete + utilisateurNbSessIncomplete} />}
        </>
        }
    </div>)
}

export default SubMenu